module.exports = __webpack_public_path__ + "static/media/highlighter.2266d270.svg";